import zoneApi from '@/api/zone.api'

export const zoneService = (function () {
  'use strict'


  /**
   * Devuelve los datos para la tabla del ABM de Grupos
   * @param {*} pageSize
   * @param {*} pageNumber
   * @param {*} headers
   */
  async function findAllPaginated(enterprises, pageSize, pageNumber, headers = false) {
    try {
      /*
      if (pageSize > 0 && pageNumber > 0) {
        const response = await zoneApi.findAllPaginated(pageSize, pageNumber, headers)
        return response.data
      } else {
        return {
          data: [],
          headers: []
        }
      }
      */
      const response = await zoneApi.findAllPaginated(enterprises, undefined, undefined, headers)
        return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  async function findAll(enterprises, geometry = true, category = '') {
    try {
      const response = await zoneApi.findAll(enterprises, geometry, category)
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Devuelve el total de zonas de la collection para el paginador de la tabla del ABM
   */
  async function getTotal(enterprises) {
    try {
      const response = await zoneApi.getTotal(enterprises)
      return response.data
    } catch (exception) {
      console.log(exception)
      return 0
    }
  }

  /**
   * Devuelve un zona con el id enviado como parámetro
   * @param {*} zoneId
   */
  async function getZone(zoneId) {
    try {
        const response = await zoneApi.getZone(zoneId)
        return response.data
    } catch (exception) {
        console.log(exception)
        return false
    }
  }

  /**
   * Para validar el nombre
   * Devuelve true si ya está asignado a un zona
   * @param {*} name
   */
  async function validateZoneName(name) {
    try {
      if (name) {
        const response = await zoneApi.validateZoneName(name)
        return response.data
      } else {
        return false
      }
    } catch (exception) {
        console.log(exception)
        return false
    }
  }

  /**
   * Para eliminar un zone
   */
  async function deleteOne(id) {
    /*
    try {
        const response = await zoneApi.deleteOne(id)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
    */
    const response = await zoneApi.deleteOne(id)
    return response.data
  }

  /**
   * Para eliminación múltiple
   */
  async function deleteMany(ids) {
    /*
    try {
        const response = await zoneApi.deleteMany(ids)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
    */
    const response = await zoneApi.deleteMany(ids)
    return response.data
  }


  /**
   * Crea una nuevo zona en la collection
   * @param {*} zone
   */
  async function create(zone) {
    /*
    try {
      const response = await zoneApi.create(zone, thingIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
    const response = await zoneApi.create(zone)
    return response.data
  }

  /**
   *  Actualiza un zona existente en la collection
   * @param {*} zone
   */
  async function update(zone) {
    /*
    try {
      const response = await zoneApi.update(zone, thingIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
   try {
      const response = await zoneApi.update(zone)
      return response.data
    } catch (exception) {
      return null
    }
  }

  async function getCategories(enterpriseId) {
    const response = await zoneApi.getCategories(enterpriseId)
    return response.data
  }

  /**
     * Valida que para actualizar el valor "zonas" del selector en ABM categorías no existan zonas con dicha categoría 
     */
  async function validateZones(categoryId) {
    const response = await zoneApi.validateZones(categoryId)
    return response.data
  }

  /**
   * Actualiza el color de múltiples zonas
   * @param {*} zoneIds - Array de IDs de zonas
   * @param {*} colorData - Objeto con color, borderColor y borderWidth
   */
  async function updateMultipleColors(zoneIds, colorData) {
      const zonesArray = await Promise.all(zoneIds.map(async zoneId => {
        
        let zone = await getZone(zoneId)
        let zoneDTO = getZoneDTO(zone, zoneId)
        zoneDTO.properties.color = colorData.color
        zoneDTO.properties.borderColor = colorData.borderColor
        zoneDTO.properties.borderWidth = colorData.borderWidth
        return zoneDTO
      }))
      
      await Promise.all(zonesArray.map(async zone => {
        await update(zone)
      }))
      
  }

  function getZoneDTO(zone,id) {
    const dto = {
      _id:id,
      type:zone.type,
      properties:zone.properties,
      geometry:zone.geometry
    }
    return dto;
  }

  return {
    findAllPaginated,
    findAll,
    getTotal,
    getZone,
    validateZoneName,
    deleteOne,
    deleteMany,
    create,
    update,
    getCategories,
    validateZones,
    updateMultipleColors
  }
})()
